import script from "./QuestionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionCard.vue?vue&type=script&setup=true&lang=js"

import "./QuestionCard.vue?vue&type=style&index=0&id=19c33f35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c33f35"]])

export default __exports__